import BaseRequest from '../lib/BaseRequest';

export default class NotificationRequest extends BaseRequest {

  getNotifications() {
    let url = '/admin/api/notifications';
    return this.get(url);
  }

  markAsRead(notificationId) {
    let url = `/admin/api/notifications/read/${notificationId}`;
    return this.get(url);
  }

}
